var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  overflow: "visible",
  preserveAspectRatio: "none",
  style: {
    display: "block"
  }
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clock_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#726855",
  strokeWidth: 1.6,
  d: "M18.398 10a8.4 8.4 0 1 1-16.8 0 8.4 8.4 0 0 1 16.8 0Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#726855",
  strokeWidth: 1.6,
  d: "m13.198 14-3.6-2.8v-6"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clock_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgClock;